import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-cotacao {
    background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
    padding: 48px 0 8px;
    overflow: hidden;
}

#seguro-auto-cotacao .cotacao-textos {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#seguro-auto-cotacao .cotacao-textos .cotacao-titulo {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
}

#seguro-auto-cotacao .cotacao-textos .cotacao-texto {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-cotacao .cotacao-servicos {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 58px 56px;
}

#seguro-auto-cotacao .cotacao-servicos .cotacao-servico {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 76px;
    height: 92px;
}

#seguro-auto-cotacao .cotacao-servico .cotacao-servico-texto {
    color: #FFF;
    text-align: center;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
}

#seguro-auto-cotacao .btn-cotacao {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: 48px auto 0;
}

#seguro-auto-cotacao .cotacao-disclaimer {
        display: block;
        margin-top: 64px;
        color: #CCC;
        font-family: "SantanderMicroText";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
    }

#seguro-auto-cotacao .img-carros {
    margin: 61px auto 0;
    display: flex;
}

@media (min-width: 992px) {
    #seguro-auto-cotacao {
        padding: 64px 0 8px;
    }

    #seguro-auto-cotacao .cotacao-textos {
        gap: 7px;
    }

    #seguro-auto-cotacao .cotacao-textos .cotacao-titulo {
        font-size: 40px;
        line-height: 60px;
        width: 667px;
    }
    
    #seguro-auto-cotacao .cotacao-textos .cotacao-texto {
        color: #FFF;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        width: 667px;
    }

    #seguro-auto-cotacao .cotacao-servicos {
        margin-top: 31px;
        margin-bottom: 48px;
        flex-wrap: nowrap;
        justify-content: flex-start;
        gap: 48px;
    }

    #seguro-auto-cotacao .cotacao-servicos .cotacao-servico {
        width: auto;
    }

    #seguro-auto-cotacao .cotacao-servicos .cotacao-servico br {
        display: none;
    }
    #seguro-auto-cotacao .btn-cotacao {
        margin: 24px 0 0;
    }

    

    #seguro-auto-cotacao .cotacao-contain {
        position: relative;
    }
    
        
    #seguro-auto-cotacao .img-carros {
        position: absolute;
        bottom: -40px;
        right: -450px;
    }

}

@media (min-width: 1100px) {
    #seguro-auto-cotacao .img-carros {
        right: -350px;
    }

}

@media (min-width: 1200px) {
    #seguro-auto-cotacao .img-carros {
        right: -280px;
    }

}`;

export default styles;